class MiniPlayer {
  constructor({ el, params, context }) {
    this.el = el;
    this.vm = context;
    this.isFixed = false;
    this.inProgress = false;
    this.parent = null;
    this.wrapper = null;
    this.parentPosition = {};
    this.wrapperPosition = {};
    this.elPosition = {
      smallWidth: 0,
      smallHeight: 0,
    };
    this.content = document.querySelector('.v-main');

    this.setParams(params);
  }

  setParams(params) {
    if ('wrapper' in params) {
      if (!this.wrapper || !this.wrapper.className.includes(params.wrapper)) this.wrapper = document.querySelector(params.wrapper);
    }
    if ('parent' in params) {
      if (!this.parent || !this.parent.className.includes(params.parent)) this.parent = document.querySelector(params.parent);
    }

    if (!this.inProgress) {
      this.inProgress = true;
      if (params.active && !this.isFixed) this.toFixedEl();
      else if (!params.active && this.isFixed) this.fromFixedEl();
      this.inProgress = false;
    }
  }

  getElPosition(elName, el) {
    const position = el.getBoundingClientRect();
    const styles = getComputedStyle(el);

    const positionObj = {
      top: position.top,
      left: position.left,
      right: window.outerWidth - position.right,
      bottom: window.outerHeight - position.bottom,
    };

    for (const key in positionObj) {
      positionObj[key] += parseFloat(styles.getPropertyValue(`margin-${key}`));
      positionObj[key] += parseFloat(styles.getPropertyValue(`padding-${key}`));
    }

    positionObj.width = position.width;
    positionObj.height = position.height;

    this[`${elName}Position`] = { ...positionObj };
  }

  getYPosition() {
    const scrollHeight = document.body.scrollHeight;
    const scrollTop = document.body.scrollTop;
    const parentHeight = this.parentPosition.top + this.parentPosition.height;
    let translateY = 0;
    if (scrollTop > parentHeight) translateY = scrollHeight - scrollTop - parentHeight - 20;
    else translateY = window.innerHeight - parentHeight - 20;
    return translateY;
  }

  toFixedEl() {
    if (!this.el.className.includes('stream-player--full-screen')) this.el.classList.remove('stream-player--full-screen');
    this.isFixed = true;
    /* ------------------Set start params--------------------- */
    this.el.style.transition = 'none';
    this.el.parentElement.style.position = 'relative';
    if (!this.el.className.includes('stream-player--mini-variant')) this.el.classList.add('stream-player--mini-variant');
    if (this.parent) this.getElPosition('parent', this.parent);
    if (this.wrapper) this.getElPosition('wrapper', this.wrapper);
    this.el.style.position = 'absolute';
    this.el.style.bottom = '0px';
    this.el.style.left = '0px';
    this.el.style.transformOrigin = 'bottom left';
    // const styles = getComputedStyle(this.el);
    // const elWidth = styles.getPropertyValue('width');
    // const elHeight = styles.getPropertyValue('height');
    // this.elPosition.smallWidth = parseFloat(elWidth);
    // this.elPosition.smallHeight = parseFloat(elHeight);
    // this.el.style.width = `${this.parentPosition.width}px`;
    // this.el.style.height = `${this.parentPosition.height}px`;

    /* ------------------Start animation--------------------- */
    this.el.style.transition = 'all .2s cubic-bezier(0.25, 0.8, 0.5, 1)';
    this.el.style.transform = `translateY(${this.getYPosition()}px)`;
    // this.el.style.width = elWidth;
    // this.el.style.height = elHeight;
    /* ------------------After animation--------------------- */
    const onEndAnimation = e => {
      if (e.target === this.el && e.propertyName === 'transform') {
        // this.el.style.width = '';
        // this.el.style.height = '';
        this.el.style.transition = 'none';
        this.el.style.transform = '';
        this.el.style.position = 'fixed';
        this.el.style.bottom = '20px';
        this.el.style.left = `${this.wrapperPosition.left}px`;

        const timeout = setTimeout(() => {
          this.el.style.transition = '';
          this.el.removeEventListener('transitionend', onEndAnimation);
          clearTimeout(timeout);
        }, 10);
      }
    };
    this.el.addEventListener('transitionend', onEndAnimation);
  }

  fromFixedEl() {
    this.el.classList.add('stream-player--mini-variant');
    if (this.parent) this.getElPosition('parent', this.parent);
    /* ------------------Set start params--------------------- */
    this.el.style.transition = 'none';
    this.el.style.position = 'absolute';
    this.el.style.bottom = `${this.getYPosition() * -1}px`;
    this.el.style.left = '0px';
    /* ------------------Start animation--------------------- */
    this.el.style.transition = 'all .2s cubic-bezier(0.25, 0.8, 0.5, 1), left 0s, bottom 0s';
    this.el.style.transform = `translateY(${this.getYPosition() * -1}px)`;
    this.el.classList.remove('stream-player--mini-variant');
    /* ------------------After animation--------------------- */
    const onEndAnimation = e => {
      if (e.target === this.el && e.propertyName === 'transform') {
        this.el.style.transition = 'none';
        this.el.style.left = '';
        this.el.style.bottom = '';
        this.el.style.position = '';
        this.el.style.transform = '';
        this.el.style.transformOrigin = '';
        this.el.parentElement.style.position = '';
        this.el.removeEventListener('transitionend', onEndAnimation);

        const timeout = setTimeout(() => {
          this.el.style.transition = '';
          this.isFixed = false;
          clearTimeout(timeout);
        }, 10);
      }
    };
    this.el.addEventListener('transitionend', onEndAnimation);
  }
}

let stickyExample;

export default {
  componentUpdated(el, value) {
    if (stickyExample) stickyExample.setParams(value.value);
  },
  inserted(el, value, vnode) {
    stickyExample = new MiniPlayer({
      el,
      params: value.value,
      context: vnode.context,
    });
  },
  unbind() {
    stickyExample = null;
  },
};
